/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
// import { IAbsentUserItem } from '@/service/work/attendanceAnalysis/type';
export default defineComponent({
  name: 'UserListItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  setup: function setup() {
    return {};
  }
});